import ActionHelper from '@wetransfer/transfer/modules/redux-actions';

export const actions = ActionHelper.types([
  'NOTIFICATION_TRANSFER_SET',
  'NOTIFICATION_TRANSFER_CLEAR',

  'NOTIFICATION_PANEL_SET',
  'NOTIFICATION_PANEL_RESET',

  'NOTIFICATION_POPOVER_SET',
  'NOTIFICATION_POPOVER_RESET',
]);

export default ActionHelper.generate({
  pushTransfer: [actions.NOTIFICATION_TRANSFER_SET, 'details'],
  clearTransfer: [actions.NOTIFICATION_TRANSFER_CLEAR],

  setNotification: [
    actions.NOTIFICATION_PANEL_SET,
    'category',
    'details',
    'params',
    'duration',
  ],
  resetNotification: [actions.NOTIFICATION_PANEL_RESET],

  setPopoverNotification: [
    actions.NOTIFICATION_POPOVER_SET,
    'category',
    'details',
  ],
  resetPopoverNotification: [actions.NOTIFICATION_POPOVER_RESET],
});
